var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeatherHeavyRain = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 19,
  fill: "none",
  viewBox: "0 0 20 18.999"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M5.416 3H4a4 4 0 0 0 0 8h12.5a3.5 3.5 0 1 0 0-7h-1.6a5.002 5.002 0 0 0-9.484-1m-1.42 10a.12.12 0 0 1 .1.048s.472.612.945 1.39c.473.78.959 1.715.959 2.448C6 18.06 5.1 19 4 19s-2-.939-2-2.113c0-.733.486-1.668.959-2.447s.945-1.39.945-1.39a.12.12 0 0 1 .08-.048zm6 0a.13.13 0 0 1 .1.048s.472.612.945 1.39c.473.78.959 1.715.959 2.448C12 18.06 11.1 19 10 19s-2-.939-2-2.113c0-.733.486-1.668.959-2.447s.945-1.39.945-1.39a.12.12 0 0 1 .08-.048zm6 0a.13.13 0 0 1 .1.048s.472.612.945 1.39c.473.78.959 1.715.959 2.448C18 18.06 17.1 19 16 19s-2-.939-2-2.113c0-.733.486-1.668.959-2.447s.945-1.39.945-1.39a.13.13 0 0 1 .08-.048z",
  clipRule: "evenodd"
})));
export default SvgWeatherHeavyRain;